import { Collapse, Modal } from 'bootstrap';

// Gets the target element from the hash value
function getTargetFromHash(hash: string): HTMLElement {
  return hash && hash.length > 1 ? document.querySelector(`[data-wf-anchor="${hash.substring(1)}"]`) as HTMLElement : null;
}

// Handles accordion scrolling behavior
function scrollToAccordion(target: HTMLElement, collapseClass: string): void {
  const targetCollapse = target.querySelector(`.${collapseClass}`) as HTMLElement;

  if (targetCollapse) {
    const panel = Collapse.getOrCreateInstance(targetCollapse, { toggle: false });
    if (targetCollapse.classList.contains('show')) {
      // Scroll immediately if already open
      target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } else {
      // Wait for panel to expand fully, then scroll
      panel.show();
      targetCollapse.addEventListener('shown.bs.collapse', () => {
        target.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }, { once: true });
    }
  }
}

// Triggers the modal linked to the id
function triggerModalById(id: string): void {
  const modalElement = document.getElementById(id);
  if (modalElement) {
    try {
      const modalInstance = Modal.getOrCreateInstance(modalElement);
      modalInstance.show();  // Trigger the modal to show
    } catch (error) {
      console.error('Error showing modal:', error);
    }
  }
}

// Allows areas to be navigated to from URL hash
function handleAnchorTarget(target: HTMLElement): void {
  if (target) {
    let type = target.getAttribute('data-wf-anchor-type');
    switch (type) {
      case 'accordion': {
        scrollToAccordion(target, 'accordion-collapse');
        break;
      }
      case 'modal': {
        if (target instanceof HTMLElement) {
          triggerModalById(target.id);
        }
        break;
      }
      case 'tab': {
        // Check if .nav-tabs is hidden (mobile view)
        const navTabs = target.closest('.nav-tabs') as HTMLElement;
        //const isHidden = window.getComputedStyle(navTabs).display === 'none';
        if (navTabs && !navTabs.offsetParent) {
          // Treat as accordion in mobile view
          target = document.querySelector(`[data-wf-anchor="accordion-${target.id}"]`) as HTMLElement;
          scrollToAccordion(target, 'accordion-tabs-collapse');
        } else {
          // Regular tab scrolling behavior
          target.click();
          navTabs.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
        break;
      }
      default: {
        console.log("Attribute 'data-wf-anchor-type' or it's value is undefined or wasn't matched.");
        break;
      }
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.modal');

  // Clear hash when modal is closed
  modals.forEach(modal => {
    if (modal.classList.contains('announcement')) {
      triggerModalById(modal.id);
      return;
    } else {
      modal.addEventListener('hidden.bs.modal', function () {
        history.replaceState(null, "", window.location.pathname);
      });
    }
  });

  handleAnchorTarget(getTargetFromHash(window.location.hash));
});

// Run when anchor link is clicked
document.addEventListener('click', (event) => {
  const anchor = event.target as HTMLAnchorElement;
  if (anchor) {
    var target = getTargetFromHash(anchor.hash)
    if (target) {
      event.preventDefault();
      handleAnchorTarget(target);
    }
  }
});

// Run when hash changes
window.addEventListener('hashchange', () => {
  handleAnchorTarget(getTargetFromHash(window.location.hash));
});
